import { useNavigate } from "react-router-dom";
import { TERMS } from "@/data/content";

export default function Terms() {
  const nav = useNavigate();
  return (
    <section className="pgwrap" style={{ maxWidth: 860 }}>
      <span className="pg-eyebrow">Legal</span>
      <h2 className="pg-h2">Terms &amp; Conditions</h2>
      <p className="pg-lead">Effective June 2026 · Governed by the laws of India. By using this website or booking a consultation, you agree to these terms.</p>
      <div className="legal-callout danger">This service is not for medical emergencies. In an emergency, call 112 or 108 or go to the nearest hospital.</div>
      <div className="legalbody">
        {TERMS.map(([h, p], i) => (
          <div key={i}>
            <h3>{i + 1}. {h}</h3>
            <p>{p}{h === "Privacy" && <> See our <a style={{ color: "var(--pine)", textDecoration: "underline", cursor: "pointer" }} onClick={() => nav("/privacy")}>Privacy policy</a>.</>}</p>
          </div>
        ))}
        <p style={{ fontSize: 12.5, color: "var(--slate)", marginTop: 18 }}>This is a design draft pending your reference document; final wording to be confirmed.</p>
      </div>
    </section>
  );
}
